import CommentsIcon from "./CommentsIcon";
import CommentsPanel from "./CommentsPanel";

export const CommentDomainName = "DomainComment";
export const CommentsColumnNameInOwnerClass = "comments";

export { CommentsIcon, CommentsPanel };
